var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"flex":""}},[_c('CrudTableExpand',_vm._b({ref:"crudTable"},'CrudTableExpand',{
      meta: _vm.meta,
      name: 'asir',
      mdTables: _vm.mdTables
    },false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }